import { Box, Skeleton } from '@mui/material';

const WorkQueueFiltersSkeleton = () => {
	return (
		<Box
			role='status'
			aria-label='Loading Work Queue filters'
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '8px',
				flexWrap: 'wrap',
				px: '12px',
				py: '8px',
				backgroundColor: 'background.subtle',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
			}}
		>
			{Array.from({ length: 4 }, (_, index) => (
				<Skeleton key={index} variant='rounded' width={110} height={28} />
			))}

			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '5px',
				}}
			>
				<Skeleton variant='text' width={88} height={18} />
				<Skeleton variant='rounded' width={34} height={20} />
			</Box>

			<Box sx={{ flex: 1 }} />

			<Skeleton variant='rounded' width={100} height={28} />
		</Box>
	);
};

export default WorkQueueFiltersSkeleton;
